export default __webpack_public_path__ + "static/media/image-not-found.80376ef9.png";